import { render, staticRenderFns } from "./Latest.vue?vue&type=template&id=66859998"
import script from "./Latest.vue?vue&type=script&lang=js"
export * from "./Latest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports